<template>
    <div>
      <img
          :src="require('@/assets/ys-top-banner.png')"
          style="max-width: 100%;display: block;position: fixed;z-index: 1000;"
          @click="handleDownload"
      />

      
      <div style="height: 64.4px;"></div>
      <div @click="handleDownload">
        <img style="width:100%;"
            :src="require('@/assets/ys.png')"/>
      </div>
      <!-- <van-swipe
          style="height: 100%;"
          class="my-swipe"
          :autoplay="3000"
          indicator-color="white"
      >
        <van-swipe-item @click="download">
            <img :src="require('@/assets/ys.png')" width="100%"></van-swipe-item>
      </van-swipe> -->
    </div>
  </template>
  
  <script>
  import { fetchList } from "@/api/notice"
  import { Base64 } from 'js-base64'
  export default {
    data () {
      return {
        active: 2,
        data: {
          list: [],
          download: {}
        },
        filter: {
          game_id: 'f30db638563d4bb7997c2f9284fa6f8b'
        }
      }
    },
    created () {
      this.getList()
    },
    methods: {
      handleDownload () {
        const u = navigator.userAgent;
        const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        let redirect_url = ''
        if (isiOS) {
          redirect_url = Base64.encodeURL(this.data.download.ios_download)
          // redirect_url = Base64.encodeURL('https://zaxhiyw.cn:7539/4oGO.html')
        } else {
          redirect_url = Base64.encodeURL(this.data.download.android_download)
          // redirect_url = Base64.encodeURL('https://zaxhiyw.cn:7539/4oGO.html')
        }
        this.$router.push({
          path: '/redirect',
          query: {
            url: redirect_url
          }
        })
      },
      getList () {
        fetchList(this.filter).then(response => {
          this.data.download = response.download
          // this.download()
        }).catch(() => {
        })
      }
    }
  }
  </script>
  
  <style>
  .van-tabs__nav--card {
    margin: 0 !important;
  }
  .van-cell__title {
    min-width: 70%;
  }
  </style>
  